import { useHookstate } from "@hookstate/core";
import { FormControlLabel, Checkbox } from "@mui/material";
import {
  FLEET_GLOBAL_STATES,
  CHECKBOX_LOADER,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useDispatch, useSelector } from "react-redux";
import { StyledCheckbox } from "./CheckboxStyled";
import { COMMON_SERVICES } from "../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { useEffect } from "react";
import { CheckIcon, UncheckIcon } from "assets/svgIcons";
import { getFeatureSetOption, getFeaturesList } from "../../../constant";
import { useTranslation } from "react-i18next";

export const WeatherCheckbox = ({ identification, disabledState }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { LoadingState, generalTabLoader,scoreCardTabLoader } = useHookstate(CHECKBOX_LOADER);
  const {
    siteSettingsDataReduxState: { WeatherAlert, PrintScorecard } = {},
    siteSettingsDataReduxState,
    siteSettingsData,
  } = useSelector((state) => state.commonReducers);
  useEffect(() => {
    if (WeatherAlert !== undefined) {
      weatherAlertGlobalState.set(WeatherAlert);
    }
    var data = !getFeatureSetOption(
      siteSettingsData &&
        siteSettingsData !== null &&
        siteSettingsData?.Features,
      getFeaturesList().real_time_tracking,
      getFeaturesList().golfer_experience
    );
    if (PrintScorecard !== undefined) {
      scoreCardPrintGlobalState.set(PrintScorecard);
    }
  }, [siteSettingsDataReduxState]);

  useEffect(() => {
    weatherAlertGlobalState.set(
      siteSettingsData && siteSettingsData?.WeatherAlert
    );
  }, [siteSettingsData]);
  const {
    weatherAlertGlobalState,
    scoreCardPrintGlobalState,
    weatherAlertPopUpDisplayer,
  } = useHookstate(FLEET_GLOBAL_STATES);

  const handleCheckboxValue = (e, identification) => {
    if (identification === "WA") {
      weatherAlertGlobalState.set(e.target.checked);
      if (e.target.checked === false) {
        LoadingState.set(true);
        generalTabLoader.set(true);
        dispatch(
          COMMON_SERVICES.putFleetSettingsServices({
            code: identification,
            Value: e.target.checked,
          }, siteId.get())
        );
        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
        weatherAlertPopUpDisplayer.set(false);
        setTimeout(() => {
          LoadingState.set(false);
          generalTabLoader.set(false);
        }, 2000);
      } else {
        weatherAlertPopUpDisplayer.set(true);
      }
    } else {
      LoadingState.set(true);
      scoreCardTabLoader.set(true);
      dispatch(
        COMMON_SERVICES.putFleetSettingsServices({
          code: identification,
          Value: e.target.checked,
        }, siteId.get())
      );

      scoreCardPrintGlobalState.set(e.target.checked);
      setTimeout(() => {
        LoadingState.set(false);
        scoreCardTabLoader.set(false);
      }, 2000);
    }
  };

  //       ######################################################################################################################################    //
  return (
    <StyledCheckbox className="checkbox">
      <FormControlLabel
        control={
          <Checkbox
            disabled={disabledState}
            icon={<UncheckIcon width={15} height={15} />}
            checkedIcon={<CheckIcon width={15} height={15} />}
            checked={
              identification === "WA" && weatherAlertGlobalState.get() !== undefined
                ? weatherAlertGlobalState.get()
                : scoreCardPrintGlobalState.get()
            }
            onClick={(e) => handleCheckboxValue(e, identification)}
          />
        }
        label={
          identification === "WA" ? t("Weather_alert") : t("Print_scorecard")
        }
      />
    </StyledCheckbox>
  );
};
